<template>
    
  <div>

    <div id="CSSCanvas"> <!--  canvas for the 3D elements-->
    </div>
    <div id="WebGLCanvas"> <!--  canvas for the 3D elements-->
    </div>

    <button class="turnOnCamera" v-on:click="turnOnCamera()"> {{cameraMessage}}</button>
    <div id="video_container">

      <div :key="reRenderLocal">
        <div
          v-for="(track, t_index) in roomConnection.localParticipant.videoTracks"
          :key="track.key"
        >
            <ThreeDimensionalVideotrack
              :participantkey="'you'"
              :publication="track"
              :trackindex="t_index"
              :scene="scene"
              :scene2="scene2"
              :camera="camera"
            />

        </div>
      </div>

      <!-- Remote Video Tracks -->
      <div :key="reRenderRoom">
        <div
          v-for="(participant, p_index) in roomConnection.participants"
          :key="participant.key"
        >
          <div
            v-for="(track, t_index) in participant[1].videoTracks"
            :key="track.key"
          >
          <!-- <div id="rotatingVideo"> -->
            <ThreeDimensionalVideotrack
              v-if="track[1].isSubscribed"
              :participantkey="participant[1].identity"
              :publication="track"
              :trackindex="calculateRemoteIndex(p_index, t_index)"
              :scene="scene"
              :scene2="scene2"
              :camera="camera"
            />
          <!-- </div> -->
          </div>
        </div>          
      </div>


      <!-- Local Audio Tracks -->
      <div :key="reRenderLocalAudio">
        <div
          v-for="track in roomConnection.localParticipant.audioTracks"
          :key="track.key"
        >
          <Audiotrack :participantkey="'you'" :publication="track" />
        </div>
      </div>

      <!-- Remote Audio Tracks -->
      <div :key="reRenderRemoteAudio">
        <div
          v-for="participant in roomConnection.participants"
          :key="participant.key"
        >
          <div v-for="track in participant[1].audioTracks" :key="track.key">
            <Audiotrack
              v-if="track[1].isSubscribed"
              :participantkey="participant[1].identity"
              :publication="track"
            />
          </div>
        </div>
      </div>

    </div>

    
  </div>
</template>

<script>


import * as THREE from 'three';
import { CSS3DRenderer, CSS3DObject } from 'three/examples/jsm/renderers/CSS3DRenderer'
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls'
import Twilio, {
  connect,
  createLocalTracks,
  createLocalVideoTrack,
  createLocalAudioTrack,
} from "twilio-video"
import Videotrack from '../Videotrack.vue';
import ThreeDimensionalVideotrack from "./ThreeDimensionalVideotrack"
import Audiotrack from '../Audiotrack'

export default {

name:"PickCard",
props: ["roomConnection","loading","cameraOptions","reRenderRoom","newRender"],
components:{
  // Videotrack,
  ThreeDimensionalVideotrack,
  Audiotrack,
},

data: function() {
  const scene = new THREE.Scene();
  const scene2 = new THREE.Scene();
  const camera = new THREE.PerspectiveCamera(75, window.innerWidth / window.innerHeight, 0.1, 2000);
  const yourVideo = document.getElementById("yourVideo");
  let id = 0;
  
  //create the CSS3DRenderer
  const renderer = new CSS3DRenderer();


  const webGLRenderer = new THREE.WebGLRenderer({ alpha:true, antialias: true });

  // const controls = new OrbitControls( camera, renderer.domElement );
  const controls = new OrbitControls( camera, webGLRenderer.domElement );

  const geometry = new THREE.SphereBufferGeometry(2, 30, 30);
  // const geometry = new THREE.SphereBufferGeometry(70,32,32);
  const geometryWireFrame = new THREE.SphereBufferGeometry(2.1, 60, 60);

  const BaseTexture = new THREE.TextureLoader().load('https://api.enter.hetnieuweinstituut.nl/uploads/TEXTURE_diffuse_Original_5afb72209e.jpg');
  const NormalMap = new THREE.TextureLoader().load('https://api.enter.hetnieuweinstituut.nl/uploads/TEXTURE_normal_7622287254.jpg');
  const HeightMap = new THREE.TextureLoader().load('https://api.enter.hetnieuweinstituut.nl/uploads/ball_texture_434d1e834c.jpeg');

  const material = new THREE.MeshStandardMaterial({ 
      map: BaseTexture,
      normalMap: NormalMap,
      displacementMap: HeightMap,
      displacementScale: .1,
      side:THREE.DoubleSide,
  });

  const materialforWireFrame = new THREE.MeshStandardMaterial({ 
    wireframe: true, opacity: .5,
    color: 0x70ffd4,
    normalMap: NormalMap,
    displacementMap: HeightMap,
    displacementScale: .1,
  });

  const color = 0xFFFFFF;
  const intensity = 1;
  const light = new THREE.AmbientLight(color, intensity);

  const cube = new THREE.Mesh( geometry, material )
  const cube2 = new THREE.Mesh( geometryWireFrame, materialforWireFrame )

  const line = new THREE.LineSegments(
    new THREE.WireframeGeometry(geometry),
    new THREE.LineBasicMaterial({
      color: 0xffffff,
      linewidth: 1,
      opacity: 0.5,
      transparent: true
    })
  );


  return{
    scene: scene,
    scene2: scene2,
    camera: camera,
    renderer: renderer,
    controls: controls,

    yourVideo:yourVideo,
    
    localCamera: null,
    cameraButtonDisabled: false,
    localIndex: 0,
    reRenderLocal: 0,
    isCameraOn: false,
    cameraMessage: "Turn on camera",
    reRender:0,
    id:id,
    reRenderRemote:0,

    webGLRenderer:webGLRenderer,
    light: light,
    cube: cube,
    cube2: cube2,
    line:line,
    
  }

},

created: function() {
  this.scene.add(this.camera)
  this.scene.add(this.light)
  this.scene.add(this.cube)
  // this.scene.add(this.cube2)
  this.scene.add(this.line);
  this.scene.add(this.planeMesh);

  this.webGLRenderer.setSize(window.innerWidth, window.innerHeight)
  // this.webGLRenderer.setClearColor( 0x0e2633, 1 )
  this.webGLRenderer.setClearColor( 0x000000, 0 );

  this.webGLRenderer.setPixelRatio(window.devicePixelRatio);
  this.webGLRenderer.setSize(window.innerWidth, window.innerHeight);
  this.webGLRenderer.shadowMap.enabled = true;
  this.webGLRenderer.shadowMap.type = THREE.PCFSoftShadowMap; // default THREE.PCFShadowMap

  // this.webGLRenderer.setClearColor( 0x000000, 0 );

  // this.scene.background = new THREE.Color('hsl(0, 100%, 100%)')

  this.camera.position.set( 0,4,4 );
  this.controls.update();
  
  this.renderer.setSize(window.innerWidth, window.innerHeight);
  this.renderer.domElement.style.position = 'absolute';
  this.renderer.domElement.style.top = 0;

  // this.renderer.setPixelRatio(window.devicePixelRatio);

  // this.camera.lookAt(this.scene.position);
  // this.controls.update(); 

},

mounted: function() {

  // const WebGLCanvas = document.getElementById("WebGLCanvas");
  
  // WebGLCanvas.appendChild(this.webGLRenderer.domElement);
  
  // const can = document.getElementById("can")
  const CSSCanvas = document.getElementById("CSSCanvas")
  console.log(CSSCanvas);
  CSSCanvas.style.position = 'absolute';
  CSSCanvas.style.top = 0;
  CSSCanvas.appendChild(this.renderer.domElement);

  
  const WebGLCanvas = document.getElementById("WebGLCanvas")
  console.log(WebGLCanvas);
  // webGLRenderer.domElement.style.zIndex =1

  WebGLCanvas.appendChild(this.webGLRenderer.domElement);
  
  // can.appendChild(this.renderer.domElement);
  // canwebGL.appendChild(this.webGLRenderer.domElement);  

  this.animate();
  
  
  // this.turnOnCamera();

},

beforeDestroy: function() {
  if(this.localCamera != null){
    this.turnOffCamera();
  }
},

methods: {
  getRndInteger: function(min, max) {
    return Math.floor(Math.random() * (max - min) ) + min;
  },




  // onDocumentMouseMove: function( event ) {
  //   mouseX = event.clientX - windowHalfX;
  //   mouseY = event.clientY - windowHalfY;
  // },

  animate: function(){
    // this.webGLRenderer.render(this.scene, this.camera)
    // this.renderer.render(this.scene,this.camera)

    this.scene2.children.forEach(el=>{
      el.rotation.x = this.camera.rotation.x;
      el.rotation.y = this.camera.rotation.y;
      el.rotation.z = this.camera.rotation.z;
    })
    this.scene.children.forEach(el=>{
      if(el.name =="backpane"){
        el.rotation.x = this.camera.rotation.x;
        el.rotation.y = this.camera.rotation.y;
        el.rotation.z = this.camera.rotation.z;
      }

    })
    this.webGLRenderer.render(this.scene, this.camera)
    this.renderer.render(this.scene2, this.camera)
    // this.camera.rotation.y  +=0.01
    this.id = requestAnimationFrame(this.animate );

    // this.camera.rotation.y +=0.01;   

    // console.log(this.scene.children);
    // this.cube.rotation.y +=0.11;
    // this.controls.autoRotate = true;
    // console.log(this.controls);

    this.controls.update();



  },

  turnOnCamera() {
    const VueThis = this;
    
    if (VueThis.localCamera == null) {
        VueThis.cameraButtonDisabled = true;
        createLocalTracks({ audio: false, video: { deviceId: this.cameraOptions[0].deviceId } }).then((track) => {
            VueThis.localIndex += 1;
            VueThis.roomConnection.localParticipant.publishTrack(track[0]);
            VueThis.localCamera = track[0];
            setTimeout(function () {
                VueThis.reRenderLocal += 1;
                VueThis.reRender += 1;
                VueThis.cameraMessage = "Turn off camera";
                VueThis.isCameraOn  = true;
                VueThis.cameraButtonDisabled = false;
            }, 1000);
        });
    } else {
        this.turnOffCamera();
    }

    // const videocontainer = document.getElementById('video_container');
    // videocontainer.appendChild(this.$props.publication[1].track.attach());

    if (VueThis.localMic == null) {
      createLocalAudioTrack().then((track) => {
        VueThis.roomConnection.localParticipant.publishTrack(track);
        VueThis.localMic = track;
        setTimeout(function () {
          VueThis.micMessage = "Turn off microphone";
          VueThis.isMicOn = true;
          VueThis.reRenderLocalAudio += 1;
        }, 1000);
      });
    } else {
      this.turnOffMic();
    }    

  },

  turnOffCamera() {
    const VueThis = this;
    VueThis.cameraMessage = "Turn on camera";
    VueThis.localCamera.stop();
    VueThis.roomConnection.localParticipant.unpublishTrack(VueThis.localCamera);
    VueThis.localCamera = null;
    VueThis.reRenderLocal += 1;
    VueThis.isCameraOn = false;
    VueThis.reRender += 1;
    
    const omTeVerwijderen = this.scene.children.find((el)=>{
      return el.element.id == "yourVideo"
    })

    // console.log(omTeVerwijderen)
    // VueThis.scene.remove(omTeVerwijderen);
    VueThis.animate()

    console.log(this.scene)


    // const VueThis = this;
    VueThis.micMessage = "Turn on microphone";
    VueThis.roomConnection.localParticipant.unpublishTrack(VueThis.localMic);
    VueThis.localMic = null;
    VueThis.isMicOn = false;
    VueThis.reRenderLocalAudio += 1;
    


  },  

  stopAnimation(){
    cancelAnimationFrame( this.id );
  },

  calculateRemoteIndex(p_index, t_index) {
    return p_index + t_index + 2;
  },

},

updated: function() {
  console.log("updated")
  console.log(this.scene)
  console.log(this.scene2)

},

beforeUpdate() {

},

watch: {
  reRenderRoom: function(newVal,oldVal){
  },

  reRenderLocal: function(newVal,oldVal) {
  },

  reRender: function(newVal,oldVal) {
  },

  newRender: function(newVal,oldVal){
  },

}

}
</script>

<style>

  .turnOnCamera{
    position: fixed;
    bottom:10px;
    left:10px;
  }

  .but{
    position: fixed;
    bottom:10px;
    left:200px;
    z-index: 10000;
  }


#WebGLCanvas, #CSSCanvas {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0; left: 0;
}

</style>